import ToastContext from './ToastContext';
import { useContext } from 'react';
import { ToastContextProps } from './model/ToastContextProps';

export const useToast = (): ToastContextProps => useContext(ToastContext);
